
/**
 * 알림 상태 정보
 */
export type NotificationGetNotifications200NotificationsItemStatus = {
  /** 읽음 상태 */
  isRead: boolean;
};
